import { ActionTree } from "vuex"
import { Booking, BookingFilter, BookingResource, BookingsFilter, BookingsState } from "~/store/bookings/bookings.types"
import { RootState } from "~/store/store.types"
import { RequestParameters } from "~/utils/SohoApi/SohoApi"
import { SohoModel } from "~/constants/SohoModel"
import { setIncludedResources } from "~/utils/store"

const actions: ActionTree<BookingsState, RootState> = {
  async fetchBookings ({ commit }, params: RequestParameters<Booking, BookingsFilter> = {}) {
    const { data, included } = await this.$sohoApi.get<BookingResource>(SohoModel.Booking, params)

    // Optionally set the included resources
    if (included) {
      setIncludedResources(included, commit)
    }

    if (data) {
      commit("SET_BOOKINGS", { params, data })
    }
  },

  async fetchBooking ({ commit }, params: RequestParameters<Booking, BookingFilter> = {}) {
    const { data, included } = await this.$sohoApi.get<BookingResource>(SohoModel.Booking, params)

    // Optionally set the included resources
    if (included) {
      setIncludedResources(included, commit)
    }

    if (data) {
      commit("SET_BOOKING", { params, data })
    }
  },

  async createBooking ({ commit }, params: Booking) {
    const { data } = await this.$sohoApi.post<Booking>(SohoModel.Booking, params)

    commit("SET_BOOKING", { data })
  },

  async updateBooking ({ commit }, params: Partial<Booking>) {
    const { data } = await this.$sohoApi.patch<Partial<Booking>>(SohoModel.Booking, params)

    commit("SET_BOOKING", { data })
  },

  async deleteBooking ({ commit }, id: string) {
    await this.$sohoApi.delete<Booking>(SohoModel.Booking, id)

    commit('DELETE_BOOKING', id)
  }
}

export default actions
